export enum BrandInvitationStatus {
  INVITED = 'invited',
  ACCEPTED = 'accepted',
}
